module.exports = __webpack_public_path__ + "img/thumbnail_AsianWaterMonitor_f_erythristic.8d8f604b.png";